module.exports = __webpack_public_path__ + "static/media/WoodConnectionType2.9c639320.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/WoodConnectionType2.png
// module id = 1187
// module chunks = 0